import React, { Component } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as SearchSVG } from "../images/svg/search.svg";
import store from "../store";

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearchResultEmpty: false,
      searchResult: [],
      categories: [],
      category: undefined
    };
    this.onChange = this.onChange.bind(this);
    this.hideSearchResult = this.hideSearchResult.bind(this);
    this.hideEditors = this.hideEditors.bind(this);
  }

  componentDidMount() {
    fetch(`${this.props.apiROOT}category/fetch`)
      .then(res => res.json())
      .then(data => {
        if (data.categories == null) return;
        this.setState({
          categories: data.categories,
          category: data.category
        });
      })
      .catch(err => {
        console.log(err);
      });


    if (document.querySelector(".navBarSearch-input").value === "") {
      document.querySelector(".navBarSearch-result").style.display = "none";
    }
  }

  hideEditors() {
    let elem = document.querySelector(".article-editor-wrapper");
    if (elem.classList.contains("visible")) {
      elem.classList.add("hide");
      elem.classList.remove("visible");

      let alertElem = document.querySelector("#alert");
      alertElem.classList.remove("success-alert");
      alertElem.classList.remove("error-alert");
      alertElem.innerHTML = "";
    }

  }

  hideSearchResult() {
    let searchElem = document.querySelector(".navBarSearch-result");
    searchElem.style.display = "none";
    document.querySelector(".navBarSearch-input").value = "";
  }

  onChange(e) {
    this.setState({ isSearchResultEmpty: false });
    let searchElem = document.querySelector(".navBarSearch-result");
    let searchValues = e.target.value;
    if (searchValues === "") {
      searchElem.style.display = "none";
      return;
    }
    searchElem.style.display = "block";

    fetch(`${this.props.apiROOT}others/search/${searchValues}`)
      .then(res => res.json())
      .then(data => {
        if (data.searchResult.length > 0) {
          this.setState({ searchResult: data.searchResult });
        } else {
          this.setState({ isSearchResultEmpty: true });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    let path = window.location.pathname.split('/');
    return (
      <React.Fragment>

        <nav className="navBar">
          <a href="/" onClick={this.hideEditors}>
            <div
              className="navBarLogo"
              style={{
                backgroundImage:
                  "url(" + this.props.root + "public/images/logo/logo.jpg)"
              }}
            />
          </a>

          <div className="navBarSearch">
            <input
              onChange={this.onChange}
              className="navBarSearch-input"
              type="text"
              placeholder="Search posts..."
            />
            <ul className="navBarSearch-result">
              {this.state.isSearchResultEmpty === false &&
                this.state.searchResult.map((res, i) =>
                  "username" in res ? (
                    <li onClick={this.hideSearchResult} key={i}>
                      <Link
                        to={`/user/${res.username.replace(/ /g, "-")}-${
                          res.user_id
                          }`}
                      >
                        <span style={{ fontWeight: 600, marginRight: 5 }}>
                          User:{" "}
                        </span>
                        {res.username}
                      </Link>
                    </li>
                  ) : (
                      <li onClick={this.hideSearchResult} key={i}>
                        <a
                          href={`${this.props.root}post/${res.post_title
                            .replace(/ /g, "-")
                            .replace(/\?/g, "")}-${res.post_id}`}
                        >
                          {res.post_title}
                        </a>
                      </li>
                    )
                )}

              {this.state.isSearchResultEmpty === true && (
                <li>No search result</li>
              )}
            </ul>
          </div>

          <div className="navBarSearch-icon">
            <Link to="/search" onClick={this.hideEditors}>
              <SearchSVG />
            </Link>
          </div>

          {parseInt(store.getState().columnOne.details.user_id) > 0 && (
            <div className="navBarNotif">
              <a href="#">
                <button className="btn shadow"
                  onClick={this.props.toggleArticleEditor}>Create Post</button>
              </a>
            </div>
          )}

          {parseInt(store.getState().columnOne.details.user_id) > 0 && (
            <React.Fragment>
              <div className="navBarProfile">
                <Link
                  onClick={this.hideEditors}
                  to={`/user/${store
                    .getState()
                    .columnOne.details.username.replace(/ /g, "-")}-${
                    store.getState().columnOne.details.user_id
                    }/`}
                >
                  {store.getState().columnOne.details.profile_image === "" ? (
                    <div
                      className="img navbar-profile-img"
                      style={{
                        backgroundImage:
                          "url(" +
                          this.props.root +
                          "public/images/profile_pic/avatar.jpg)"
                      }}
                    >
                      <img
                        className="img-decoy"
                        alt={store.getState().columnOne.details.username}
                      />
                    </div>
                  ) : (
                      <div
                        className="img navbar-profile-img"
                        style={{
                          backgroundImage:
                            "url(" +
                            this.props.root +
                            "public/images/profile_pic/" +
                            store.getState().columnOne.details.profile_image +
                            ")"
                        }}
                      >
                        <img
                          className="img-decoy"
                          alt={store.getState().columnOne.details.username}
                        />
                      </div>
                    )}
                </Link>
              </div>

              {store.getState().columnOne.details.acl > 0 && (
                <div className="navBarAdmin-link">
                  <Link to={`/admin`}>
                    <button className="btn shadow">Admin</button>
                  </Link>
                </div>
              )}
            </React.Fragment>
          )}

          {parseInt(store.getState().columnOne.details.user_id) < 1 && (
            <React.Fragment>
              <a href={`${this.props.root}register`}>
                <div className="navBarRegister">
                  <button className="btn">Get started</button>
                </div>
              </a>

              <a href={`${this.props.root}login`}>
                <div className="navBarLogin">
                  <button className="btn">Login</button>
                </div>
              </a>
            </React.Fragment>
          )}
        </nav>


        <div className="cat-s">
          <ul className="cat-s-ul">
            {this.state.categories.map(c =>
              <li key={c.category_id}>
                <a href={`/category/${c.category.replace(/ /g, "-")}`}
                  style={{ backgroundColor: (c.category !== undefined) && (c.category == path[path.length - 1].replace(/-/g, " ")) ? "#111111" : '' }}>
                  {c.category}
                </a>
              </li>)}
 
          </ul>
          <div className="clear-float"></div>
        </div>
      </React.Fragment>
    );
  }
}

export default NavBar;
